export const START_COUNTDOWN_THRESHOLD = 60000;
export const IMPENDING_START_THRESHOLD = 15000;
export const IMPENDING_END_THRESHOLD = 10000;

/**
 * Exclusive phases of a lesson that can be used derive other lesson related UI
 * events.
 */
export const enum LessonPhase {
  None,
  StartCountdown,
  ImpendingStart,
  StartElapsed,
  GracePeriod,
  ImpendingEnd,
  EndElapsed,
}

/**
 * Describes how the lesson button should be displayed to the user.
 */
export const enum LessonButtonStage {
  // Do nto show a button
  None,
  // apply different start button styles.
  ShowReadyPulsing,
  // apply different end button styles
  ShowEnd,
  ShowEndUrgent,
}

/**
 * Decides where the lesson button should be rendered.
 */
export const enum LessonButtonPositionStage {
  None,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Notification,
  TimeDetails,
}

/**
 * Describes what sounds should be looping.
 */
export const enum LessonSoundStage {
  None,
  Start,
}

/**
 * Describes how the time should be displayed to the user.
 */
export const enum LessonTimeStage {
  None,
  Urgent,
}

/**
 * Describes UI state for a lesson that is not centralized in a single component.
 */
export interface ILessonUIState {
  button: LessonButtonStage;
  buttonPosition: LessonButtonPositionStage;
  phase: LessonPhase;
  sound: LessonSoundStage;
  time: LessonTimeStage;
}

export const defaultLessonUIState: ILessonUIState = {
  button: LessonButtonStage.None,
  buttonPosition: LessonButtonPositionStage.None,
  phase: LessonPhase.None,
  sound: LessonSoundStage.None,
  time: LessonTimeStage.None,
};
